export const lcvOrdersConstants = {
    LCV_ORDERS_PREVIEW_IMPORT_REQUEST:"LCV_ORDERS_PREVIEW_IMPORT_REQUEST",
    LCV_ORDERS_PREVIEW_IMPORT_COMPLETE:"LCV_ORDERS_PREVIEW_IMPORT_COMPLETE",

    LCV_ORDERS_IMPORT_REQUEST:"LCV_ORDERS_IMPORT_REQUEST",
    LCV_ORDERS_IMPORT_COMPLETE:"LCV_ORDERS_IMPORT_COMPLETE",

    LCV_ORDERS_CLEAR_IMPORT:"LCV_ORDERS_CLEAR_IMPORT",

    LCV_ORDERS_GET_IMPORT_HISTORY_REQUEST:"LCV_ORDERS_GET_IMPORT_HISTORY_REQUEST",
    LCV_ORDERS_GET_IMPORT_HISTORY_COMPLETE:"LCV_ORDERS_GET_IMPORT_HISTORY_COMPLETE",
};
